import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { MeasureProtocolService } from '../services/measure-protocol.services';
import { FeatureKey } from 'src/app/_models';

@Injectable()
export class MeasureProtocolListResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule'));
    let moduleId = workingModule ? workingModule.id : 0;
    return this.backend.getAllMeasureProtocol(
      moduleId,
      +route.params['Id'],
      route.parent.parent.data['parent']
    );
  }
}

@Injectable()
export class CompleteMeasureProtocolListResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.backend.getAllCompleteMeasureProtocol(
      +route.params['Id'],
      route.parent.parent.data['parent']
    );
  }
}

@Injectable()
export class MeasureProtocolEditResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return of(true);
  }
}

@Injectable()
export class InstrumentListResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (+route.parent.params['mid'] > 0) {
      return this.backend.getAllInstruments(+route.parent.params['mid']);
    } else {
      return null;
    }
  }
}

@Injectable()
export class CMPInstrumentListResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (+route.parent.params['mpcid'] > 0) {
      return this.backend.getAllCMPInstruments(+route.parent.params['mpcid']);
    } else {
      return null;
    }
  }
}

@Injectable()
export class InstrumentEditResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.backend.getInstrumentById(
      +route.parent.params['mpcid'],
      route.params['id']
    );
  }
}

@Injectable()
export class MeasureProtocolCompleteEditResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.backend.getMeasureProtocolCompleteById(
      +route.params['id'],
      route.parent.parent.params['id']
    );
  }
}

@Injectable()
export class TypeListResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getAllByType(
      +route.parent.parent.parent.params['id'],
      route.parent.parent.parent.data['parent']
    );
  }
}

@Injectable()
export class ModelListResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getAllByModel(
      +route.parent.parent.parent.params['id'],
      route.parent.parent.parent.data['parent']
    );
  }
}

@Injectable()
export class PowerLeakageListResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (+route.parent.params['mpcid'] > 0) {
      return this.backend.getAllPowerLeakage(+route.parent.params['mpcid']);
    } else {
      return null;
    }
  }
}

@Injectable()
export class EarthLeakageListResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (+route.parent.params['mpcid'] > 0) {
      return this.backend.getAllEarthLeakage(+route.parent.params['mpcid']);
    } else {
      return null;
    }
  }
}

@Injectable()
export class CMPTemperatureListResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (+route.parent.params['mpcid'] > 0) {
      return this.backend.getAllCMPTemperature(+route.parent.params['mpcid']);
    } else {
      return null;
    }
  }
}

@Injectable()
export class TemperatureTypeListResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getAllByTemperatureType(
      +route.parent.parent.parent.params['id'],
      route.parent.parent.parent.data['parent'],
      FeatureKey.KUNDE_EL
    );
  }
}

@Injectable()
export class TemperatureModelListResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getAllByTemperatureModel(
      +route.parent.parent.parent.params['id'],
      route.parent.parent.parent.data['parent'],
      FeatureKey.KUNDE_EL
    );
  }
}

@Injectable()
export class VisualControlResolver {
  constructor(private backend: MeasureProtocolService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getVisualControl(+route.parent.params['mpcid']);
  }
}
